module.exports = __webpack_public_path__ + "img/av238.8ff45adb.png";